@if (element) {
  <app-card [showHeader]="false">
    <div class="row align-item-center">
      <div class="col-8">
        <div class="text-muted f-w-500">
          <span class="m-b-5 f-w-500"
                [class.text-warn-500]="element.status === 'unsupported' || element.status === 'expired' "
                [class.text-primary-500]="element.status === 'pending'"
                [class.text-success-500]="element.status === 'success'"
          >
            @switch (element?.status) {
              @case ('expired') {
                Comando fallido
              }
              @case ('unsupported') {
                Comando no soportado
              }
              @case ('success') {
                Comando exitoso
              }
              @default {
                Comando pendiente
              }
            }
          </span>
          <p class="m-b-5 f-16 f-w-600">{{ complementKey?.label?.['es'] || complementKey?.label?.['default'] }}</p>

          @if (complementKey?.value === 'personalizeCommand') {
            <p class="badge">
              <code>{{ element?.customText }}</code>
            </p>
          }

          @switch (element?.status) {
            @case ('expired') {
              <p>No se pudo confirmar la recepcion del comando por parte del dispositivo</p>
            }
            @case ('unsupported') {
              <p>El comando o canal no esta soportado para ser enviado por esta dispositivo.</p>
            }
            @case ('success') {
              <p>El comando fue enviado y confirmado correctamente.</p>
            }
            @default {

            }
          }

        </div>
        <div class="text-muted f-w-500 m-t-10">
          <span>
            <strong>Canales: </strong>
          </span>
          @for (channel of element?.channelKeys || []; track channel) {
            <span
              class="badge"
              [class.bg-primary-200]="channel === element?.channelCurrentKey"
              [class.bg-default-500]="channel !== element?.channelCurrentKey"
            >
              {{ channel }}
            </span>
          }

          @if (element?.status === 'pending') {
            <span class="badge bg-primary-100 m-l-10">
                @switch (element?.retries) {
                  @case (0) {
                    Enviando ...
                  }
                  @case (1) {
                    Enviado
                  }
                  @case (2) {
                    Reintentando
                  }
                  @default {
                    {{ element?.retries - 1 }} Reintentos
                  }
                }
              </span>
          }

          @if (element?.responseText?.length) {
            <span (click)="showResponseText = !showResponseText" class="badge bg-primary-100 m-l-10">
              @if (showResponseText) {
                Ocultar respuesta
              } @else {
                Ver respuesta
              }
            </span>
          }

        </div>

      </div>
      <div class="col-4 text-end"
           [class.text-warn-500]="element.status === 'unsupported' || element.status === 'expired' "
           [class.text-primary-500]="element.status === 'pending'"
           [class.text-success-500]="element.status === 'success'"
      >
        <i class="fi fi-rr-paper-plane f-36"></i>

        @if (element.status === 'unsupported' || element.status === 'expired') {
          <i class="fi fi-sr-times-hexagon f-18 " style="margin-left: -10px"></i>
        }
        @if (element.status === 'unsupported' || element.status === 'pending') {
          <i class="fi fi-sr-hourglass-end f-18" style="margin-left: -10px"></i>
        }
        @if (element.status === 'unsupported' || element.status === 'success') {
          <i class="fi fi-ss-hexagon-check f-18" style="margin-left: -10px"></i>
        }
      </div>
    </div>

    @if (showResponseText) {
      <br />
      <app-card [showHeader]="false" padding="10">
        {{ element?.responseText }}
      </app-card>
    }

    @if (element.status === 'pending') {
      <br />
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    }
  </app-card>
}
